/* Font Awesome Free 6.7.2 by @fontawesome
 * https://fontawesome.com License
 * https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.
 */

import React from "react";
import { BaseIconProps } from "../../types/styles";

const CheckCircleIcon = ({
    id,
    className,
    size = 30,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--success-500)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-circle-check"}
            className={className}
            height={size}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
        >
            <path
                fill={color}
                d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
            />
        </svg>
    );
};

export default CheckCircleIcon;
